import { render, staticRenderFns } from "./SettingPayment.vue?vue&type=template&id=9b05973c"
import script from "./SettingPayment.vue?vue&type=script&lang=js"
export * from "./SettingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports